<script setup>
import { computed, ref } from 'vue';
import Modal from './Modal.vue';
import PrimaryButton from './PrimaryButton.vue';
import { useStore } from 'vuex';
import { dispatchNotification } from './Notification';
import Multiselect from '@vueform/multiselect'

const emit = defineEmits(['closes', 'created']);
const props = defineProps(['userId']);

const store = useStore();
const csrfToken = store.state.csrfToken;

const industries = computed(() => {
    return JSON.stringify(model.value.value);
})

const initialFormState = {
    user_id: props.userId,
    title: '',
    type: '',
    industry: industries,
    errors: '',
    processing: false,
};

const model = ref({
    mode: 'tags',
    value: [],
    placeholder: 'Branchen auswählen...',
    closeOnSelect: false,
    searchable: true,
    allowAbsent: true,
    options: [
        "Alle Branchen",
        "Agrar, Chemie, Rohstoffe",
        "IT und Telekommunikation",
        "Sport und Freizeit",
        "Tourismus und Gastronomie",
        "Bauen und Wohnen",
        "Handel und Handwerk",
        "Energie und Umwelt",
        "Finanzen und Immobilien",
        "Medien und Marketing",
        "Technik und Industrie",
        "Gesundheit und Soziales",
        "Verwaltung und Öffentliche Hand",
        "Bildung",
        "Auto und Mobilität",
        "Textil"
    ],
    noResultsText: 'Keine weiteren Branchen.',
    noOptionsText: 'Keine Branchen gefunden.',
    createOption: false
});

const form = ref({ ...initialFormState });

const resetForm = () => {
    Object.assign(form.value, initialFormState);
}

const submit = () => {
    form.value.processing = true;

    fetch('/api/job-requests', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'X-CSRF-TOKEN': csrfToken,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(form.value)
    }).then(async (response) => {
        const jobRequest = await response.json();
        form.value.processing = false;

        if (response.status === 422) {
            form.value.errors = json.errors;
        } else if (response.status === 201) {
            dispatchNotification({ title: 'Aktion erfolgreich', content: 'Die Interesse wurde erfolgreich angelegt.', type: 'success', duration: 5000 });
            resetForm();
            emit('created', jobRequest);

        } else {
            dispatchNotification({ title: 'Es ist ein Fehler aufgetreten', content: 'Fehlercode: ' + response.status, type: 'error', duration: 5000 });
        }
    }).catch((error) => {
        console.log(error);
    });
};

</script>

<template>
    <Modal :show="true" @closes="emit('closes')" max-width="3xl">
        <template #headers>
            <h3 class="tw-text-base tw-font-semibold tw-leading-6 tw-text-gray-900 tw-mb-0">Weitere Berufe oder Branchen
                eingeben
            </h3>
            <p class="tw-mt-1 tw-text-sm tw-text-gray-500 tw-mb-0">Hier kannst du weitere Berufe oder Branchen eingeben.
            </p>
        </template>

        <form @submit.prevent="submit" class="tw-space-y-3 tw-px-6 tw-py-5">
            <div class="tw-grid tw-grid-cols-1 tw-gap-x-8 tw-gap-y-10 tw-pb-3 md:tw-grid-cols-3 border-gray-900/10">
                <div class="tw-bg-gray-100 tw-p-5 tw-rounded-lg">
                    <h2 class="tw-text-base tw-font-semibold tw-leading-7 tw-text-gray-900">Allgemeine
                        Informationen</h2>
                    <p class="tw-mt-1 tw-text-sm tw-leading-6 tw-text-gray-600">Gib die allgemeinen Informationen zu dem
                        Beruf oder der Branche ein.</p>
                </div>

                <div
                    class="tw-grid tw-max-w-3xl tw-grid-cols-1 tw-gap-x-6 tw-gap-y-4 sm:tw-grid-cols-6 md:tw-col-span-2 tw-py-5">

                    <div class="sm:tw-col-span-6">
                        <label :for="'job-request-type'">Ich suche ... *</label>
                        <select v-model="form.type" :id="'job-request-type'" class="custom-select" required>
                            <option value="">Auswählen...</option>
                            <option value="Vollzeit-Job">einen Vollzeit-Job</option>
                            <option value="Teilzeit-Job">einen Teilzeit-Job</option>
                            <option value="Mini/Midi-Job">einen Mini/Midi-Job</option>
                            <option value="Ausbildung">einen Ausbildungsplatz</option>
                            <option value="Duales Studium">ein Duales Studium</option>
                            <option value="BFD/FSJ">ein BFD/FSJ</option>
                        </select>
                    </div>



                    <div class="sm:tw-col-span-6">
                        <label :for="'job-request-industry'">... in der Branche ... *</label>
                        <Multiselect v-model="model.value" v-bind="model" required />
                    </div>

                    <div class="sm:tw-col-span-6">
                        <label :for="'job-request-title'">... mit der Berufsbezeichnung ... *</label>
                        <input v-model="form.title" type="text" :id="'job-request-title'"
                            placeholder="Berufsbezeichnung" class="form-control" required>
                    </div>

                </div>
            </div>

            <div class="tw-flex tw-items-center tw-justify-end">
                <PrimaryButton class="!tw-w-auto" :loading="form.processing">
                    Speichern
                </PrimaryButton>
            </div>

        </form>


    </Modal>
</template>
